export default "__VITE_ASSET__7xVGcvsq__"